goog.provide('el8.appchart.dialog.viewAllTemplates');

goog.require('el8.appservice.notifier');
goog.require('el8.template.appchart.dialog.viewAllTemplates');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.consts');


/**
 * This file is currently responsible only for viewing letter templates.
 * Ideally, it would also handle visitnote templates, but at the moment,
 * the files for those templates assume some facts unique to visinote checklists.
 * We didn't unify the files, since we'd have to throw out most of the unified
 * files anyways to produce searchable/ranked templates we actually like.
 */
el8.appchart.dialog.viewAllTemplates = (function() {

    var selectedCb = null;
    var templateSet = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'All Letter and Referral Templates',
        autoHeight: true,
        position: 'center',
        width: 500,
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.template-item',  function(event) {
            var itemId = $(this).attr('data-id');
            var template = templateSet.getById(itemId);
            if (selectedCb) { selectedCb(template); }
            that.hide();
        });
    };

    var super_show = that.show;
    that.show = function(opts) {
        super_show.call(that);

        templateSet = opts.templateSet;
        selectedCb = opts.selectedCb;

        // if we've already loaded this set, no event will fire, so
        // we need to call renderTemplates manually in the successCb;
        // the bind will then catch future updates while the dialog is open
        templateSet.softLoad(renderTemplates, true);
        templateSet.bind('all', renderTemplates);
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.getContentElt().empty();
        templateSet.unbind('all', renderTemplates);
        templateSet = null;
        selectedCb = null;
    };

    function renderTemplates() {
        var url;
        if (templateSet === el8.practicedata.letterTemplates) {
            url = '/settings/templates/';
        }
        that.setContent(el8.template.appchart.dialog.viewAllTemplates.content({
            templates: templateSet.allAsSoyMaps(),
            settingsUrl: url
        }));
        that.adjustPosition();
    }

    return that;

})();
